module.exports = __webpack_public_path__ + "static/media/05(5).b32bc2af.jpg";